import get from 'lodash/get'
import * as React from 'react'
import type { EmailCampaignUser } from 'types/campaign'
import HelpTooltip from 'components/common/tooltip'
type Props = {
  user: EmailCampaignUser
  eventList: 'tracks_events' | 'playlists_events'
  eventProp: 'downloads' | 'streams'
  caption: string
  value: number
}

/**
 * User list statistic component with tooltip showing detailed breakdown
 * Displays a value with hover tooltip containing event-specific statistics
 * @param user - Email campaign user object containing event data
 * @param eventList - Property name for the event array ('tracks_events' or 'playlists_events')
 * @param eventProp - Property name for the specific metric ('downloads' or 'streams')
 * @param caption - Caption text to display in the tooltip header
 * @param value - The aggregated value to display
 */
const UserListStat = ({
  user,
  eventList,
  eventProp,
  caption,
  value,
}: Props): React.ReactNode | number => {
  const eventArray: Record<string, any>[] = get(user, eventList, [])
  const stats = eventArray
    .filter(event => get(event, eventProp, 0) > 0)
    .map(event => (
      <div key={event.id}>{`${event.name} - ${get(event, eventProp, 0)}`}</div>
    ))
  if (value === 0) return value
  return (
    <HelpTooltip base={<div>{value}</div>} customScrollbars>
      <b>{caption}</b>
      <br />
      <br />
      {stats}
    </HelpTooltip>
  )
}

export default UserListStat
